/**
 * Decides when an opened chat thread should auto-scroll.
 * Instant jump on conversation switch; later only when a new message arrives
 * and the agent is already near the bottom.
 */
export class OpenedChatScrollController {
  static NEAR_BOTTOM_PX = 80;

  constructor() {
    this._conversationId = null;
    this._lastCount = 0;
    this._nearBottom = true;
    this._showChip = false;
  }

  get showChip() {
    return this._showChip;
  }

  dismissChip() {
    this._showChip = false;
  }

  /**
   * @param {HTMLElement | null | undefined} container
   * @returns {boolean}
   */
  isNearBottom(container) {
    if (!container) return true;
    const gap = container.scrollHeight - container.scrollTop - container.clientHeight;
    return gap <= OpenedChatScrollController.NEAR_BOTTOM_PX;
  }

  /**
   * @param {HTMLElement | null | undefined} container
   */
  recordScrollPosition(container) {
    this._nearBottom = this.isNearBottom(container);
    if (this._nearBottom) this._showChip = false;
  }

  /**
   * @param {string | number | null | undefined} conversationId
   * @param {number} messageCount
   * @returns {{ behavior: 'auto' | 'smooth' | null, showChip: boolean }}
   */
  evaluate(conversationId, messageCount) {
    const convKey = conversationId == null ? "" : String(conversationId);
    const count = Number(messageCount) || 0;
    const switched = convKey !== this._conversationId;

    if (switched) {
      this._conversationId = convKey;
      this._lastCount = count;
      this._nearBottom = true;
      this._showChip = false;
      return { behavior: "auto", showChip: false };
    }

    if (count > this._lastCount) {
      this._lastCount = count;
      if (this._nearBottom) {
        this._showChip = false;
        return { behavior: "smooth", showChip: false };
      }
      this._showChip = true;
      return { behavior: null, showChip: true };
    }

    this._lastCount = count;
    return { behavior: null, showChip: this._showChip };
  }
}
